import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Search14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.5 1.25C4.6005 1.25 2.25 3.6005 2.25 6.5C2.25 7.67927 2.63881 8.76772 3.29523 9.64416L0.469727 12.4697L1.53039 13.5303L4.3559 10.7048C5.23233 11.3612 6.32076 11.75 7.5 11.75C10.3995 11.75 12.75 9.3995 12.75 6.5C12.75 3.6005 10.3995 1.25 7.5 1.25ZM3.75 6.5C3.75 4.42893 5.42893 2.75 7.5 2.75C9.57107 2.75 11.25 4.42893 11.25 6.5C11.25 8.57107 9.57107 10.25 7.5 10.25C5.42893 10.25 3.75 8.57107 3.75 6.5Z'
      fill='currentColor'
    />
  </Svg>
);

Search14.displayName = 'Search14';
export default Search14;
